// components/monitoring/T247VlanModal.js
import React from "react";
import { createPortal } from "react-dom";
import { fmt2 } from "./t247Shared";

const T247VlanModal = ({ vlan, onClose }) => {
  if (!vlan) return null;
  const sortedClients = [...(vlan.clientList || [])].sort((a, b) => (b.total_usage || 0) - (a.total_usage || 0));

  const content = (
    <div className="t247-modal-overlay t247" onClick={onClose}>
      <div className="t247-modal" onClick={(e) => e.stopPropagation()}>
        <div className="t247-modal-header">
          <span className="t247-modal-title">VLAN {vlan.vlan} · {vlan.name.toUpperCase()}</span>
          <button className="t247-modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="t247-modal-info">
          <span>{vlan.clients} client{vlan.clients === 1 ? "" : "s"}</span>
          {vlan.vlanInfo?.vlan_ip && <span>IP {vlan.vlanInfo.vlan_ip}</span>}
          {vlan.vlanInfo?.netmask && <span>Mask {vlan.vlanInfo.netmask}</span>}
        </div>

        <div className="t247-modal-body">
          <div className="t247-modal-section-title">TOTAL TRAFFIC</div>
          <div className="t247-modal-grid">
            <Cell k="↓ DOWNLOAD" v={`${fmt2(vlan.download)} GB`} />
            <Cell k="↑ UPLOAD" v={`${fmt2(vlan.upload)} GB`} />
            <Cell k="Σ TOTAL" v={`${fmt2(vlan.total)} GB`} />
            <Cell k="SHARE OF SITE" v={`${vlan.pct.toFixed(1)}%`} />
          </div>

          <div className="t247-modal-section-title">
            CLIENTS ({sortedClients.length})
          </div>
          {sortedClients.length === 0 ? (
            <div style={{ padding: "0 20px 18px", font: "400 11px 'DM Mono',monospace", color: "var(--text-muted)" }}>No clients currently on this VLAN.</div>
          ) : (
            <div>
              <div className="t247-modal-row" style={{ borderBottom: "1px solid var(--line)", background: "var(--navy-700)" }}>
                <span style={{ flex: 1, font: "400 9.5px 'DM Mono',monospace", letterSpacing: "0.1em", color: "var(--text-muted)" }}>CLIENT</span>
                <span style={{ width: 70, textAlign: "right", font: "400 9.5px 'DM Mono',monospace", letterSpacing: "0.1em", color: "var(--text-muted)" }}>↓ GB</span>
                <span style={{ width: 70, textAlign: "right", font: "400 9.5px 'DM Mono',monospace", letterSpacing: "0.1em", color: "var(--text-muted)" }}>↑ GB</span>
                <span style={{ width: 70, textAlign: "right", font: "400 9.5px 'DM Mono',monospace", letterSpacing: "0.1em", color: "var(--text-muted)" }}>Σ GB</span>
              </div>
              {sortedClients.map((c, i) => (
                <div className="t247-modal-row" key={i}>
                  <span style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ font: "700 12px 'DM Sans',sans-serif", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.name}</div>
                    <div style={{ font: "400 10.5px 'DM Mono',monospace", color: "var(--text-muted)" }}>{c.ip_address}</div>
                  </span>
                  <span style={{ width: 70, textAlign: "right", font: "400 12px 'DM Mono',monospace" }}>{fmt2((c.download || 0) / 1024)}</span>
                  <span style={{ width: 70, textAlign: "right", font: "400 12px 'DM Mono',monospace" }}>{fmt2((c.upload || 0) / 1024)}</span>
                  <span style={{ width: 70, textAlign: "right", font: "700 12px 'DM Mono',monospace" }}>{fmt2((c.total_usage || 0) / 1024)}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="t247-modal-footer">
          <button className="t247-btn t247-btn-primary" onClick={onClose}>CLOSE</button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.getElementById("modal-root") || document.body);
};

const Cell = ({ k, v }) => (
  <div className="t247-modal-cell">
    <div className="k">{k}</div>
    <div className="v">{v}</div>
  </div>
);

export default T247VlanModal;
